var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#E3E4E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0008,
    cy: 10.4,
    r: 3.2,
    fill: "#202E5F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 14.3813C9.10768 14.3813 6 16.8442 6 20.0001C6.54583 20.6349 9.04 22.0001 11.6 22.0001C14.9153 22.0001 17.1871 20.7305 18 20.0956C18 16.9397 14.8935 14.3813 12.0006 14.3813Z",
    fill: "#202E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16C12.1447 16 12.2834 16.0575 12.3857 16.1598C12.488 16.2621 12.5455 16.4008 12.5455 16.5455V17.4545H13.4545C13.5992 17.4545 13.7379 17.512 13.8402 17.6143C13.9425 17.7166 14 17.8553 14 18C14 18.1447 13.9425 18.2834 13.8402 18.3857C13.7379 18.488 13.5992 18.5455 13.4545 18.5455H12.5455V19.4545C12.5455 19.5992 12.488 19.7379 12.3857 19.8402C12.2834 19.9425 12.1447 20 12 20C11.8553 20 11.7166 19.9425 11.6143 19.8402C11.512 19.7379 11.4545 19.5992 11.4545 19.4545V18.5455H10.5455C10.4008 18.5455 10.2621 18.488 10.1598 18.3857C10.0575 18.2834 10 18.1447 10 18C10 17.8553 10.0575 17.7166 10.1598 17.6143C10.2621 17.512 10.4008 17.4545 10.5455 17.4545H11.4545V16.5455C11.4545 16.4008 11.512 16.2621 11.6143 16.1598C11.7166 16.0575 11.8553 16 12 16Z",
    fill: "#E3E4E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/staffIcon.2e960ba2e4aa4886bf0a2dcd558c2d1a.svg";
export { ForwardRef as ReactComponent };